import React from "react";
import { type StyleProp, StyleSheet, type ViewStyle } from "react-native";

import { palette, spacing } from "../styles";
import Block from "./Block";
import Typography from "./Typography";

type Props = {
  separator?: string;
  spaceless?: boolean;
  style?: StyleProp<ViewStyle>;
  color?: string;
  vertical?: boolean;
  width?: number;
  height?: number;
};

const Divider = ({
  style,
  separator,
  spaceless = false,
  color = palette.common.lightGray,
  vertical = false,
  width = spacing.unit * 0.125,
  height,
}: Props) => (
  <Block
    alignCenter
    justifyCenter
    paddingHorizontal={vertical ? 1 : 0}
    paddingVertical={Number(!spaceless)}
    row={!vertical}
    style={style}
  >
    {separator ? (
      <>
        <Block style={[styles.divider, { backgroundColor: color }]} />
        <Typography style={styles.separator} type="secondary">
          {separator}
        </Typography>
        <Block style={[styles.divider, { backgroundColor: color }]} />
      </>
    ) : (
      <Block
        style={[
          styles.divider,
          vertical && { width },
          height && { height, borderRadius: height * 2 },
          { backgroundColor: color },
        ]}
      />
    )}
  </Block>
);

export default React.memo(Divider);

const styles = StyleSheet.create({
  divider: {
    flex: 1,
    height: StyleSheet.hairlineWidth,
  },
  separator: {
    marginHorizontal: spacing.unit * 2,
  },
});
